import type { Components, Theme } from '@mui/material/styles';

export const surfaceComponents: Components<Theme> = {
    MuiAvatar: {
        defaultProps: {
            variant: 'rounded',
        },
    },

    MuiPaper: {
        styleOverrides: {
            root: {
                backgroundImage: 'none',
            },
        },
    },

    MuiDialog: {
        styleOverrides: {
            root: ({ theme }) => ({
                '& .MuiBackdrop-root': {
                    backgroundColor:
                        theme.palette.mode === 'dark'
                            ? 'rgba(0, 0, 0, 0.44)'
                            : 'rgba(15, 23, 42, 0.28)',
                    backdropFilter: 'blur(5px)',
                    WebkitBackdropFilter: 'blur(5px)',
                },
            }),
        },
    },

    MuiSkeleton: {
        styleOverrides: {
            root: ({ theme }) => ({
                borderRadius: theme.shape.borderRadius,
                width: '100%',
            }),
        },
    },
};